import React from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login'
import MyAccount from './pages/MyAccount'
import InviteTeam from './pages/InviteTeam';
import Logout from './pages/Logout';
import App from './pages/App';
import DailyReports from './pages/DailyReports'
import DailyReportsGate from './pages/DailyReportsGate';
import FreeTrial from './pages/FreeTrial';
import AdminApp from './admin/App';
import { MaterialUIControllerProvider } from './admin/context';
import AdminGuard from './components/AdminGuard';
import reportWebVitals from './reportWebVitals';
import Privacy from './pages/Privacy';

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/daily-reports" element={<DailyReportsGate />} />
      <Route path="/free-trial" element={<FreeTrial />} />
      <Route path="/cockpit" element={<App />} />
      <Route path="/account" element={<MyAccount />} />
      <Route path="/invite-team" element={<InviteTeam />} />
      <Route path="/map" element={<App />} />
      <Route path="/admin/*" element={
        <AdminGuard>
          <MaterialUIControllerProvider>
            <AdminApp />
          </MaterialUIControllerProvider>
        </AdminGuard>
      } />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();
